import React, { useState } from 'react';
import { Table } from '@mui/material';
import { useSelector } from 'react-redux';
import { ROLE_VALUE } from '@src/constants';
import { StyledTable } from './index.style';
import CustomTableHeader from './TableHeader';
import CustomTableBody from './TableBody';
import CustomTableFooter from './TableFooter';
import NoData from '../NoData';

// columns, data, total, page, onChangePage are required
const CustomTable = ({
  columns,
  data,
  total,
  page,
  sort,
  cellWidth,
  selection,
  loading,
  showNumber,
  onChangePage,
  onChangeSort,
  onRowClick,
}) => {
  const [selected, setSelected] = useState([]);
  const { account } = useSelector((state) => state.auth);

  const hasPermissions = (permissions = []) => {
    if (!permissions) return true;
    if (Array.isArray(permissions)) {
      return permissions.some((p) => account.permissions.includes(p));
    }
    return account.permissions.includes(permissions);
  };

  const isSelected = (id) => selected.includes(id);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelected = data.map((rowData) => rowData.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleSelectRow = (id) => (event) => {
    if (event.target.checked && !selected.includes(id)) {
      setSelected([...selected, id]);
      return;
    }
    setSelected(selected.filter((item) => item !== id));
  };

  // Show all columns if the account has super admin role
  // or filter columns based on required permissions
  const isSuperAdmin = account?.roles?.includes(ROLE_VALUE.SUPER_ADMIN);
  const filteredColumns = isSuperAdmin
    ? columns
    : columns.filter(
        (col) =>
          !col?.requiredPermission || hasPermissions(col?.requiredPermission),
      );

  // TODO: fixed table body height when change page
  // TODO: add loading data and show no data
  // TODO: add handle when selection checkbox
  return (
    <>
      <StyledTable cellwidth={cellWidth}>
        <Table>
          <CustomTableHeader
            columns={filteredColumns}
            selection={selection}
            sort={sort}
            showNumber={showNumber}
            numSelected={selected.length}
            rowCount={data.length}
            onSelectAll={handleSelectAll}
            onChangeSort={onChangeSort}
          />
          <CustomTableBody
            page={page}
            columns={filteredColumns}
            data={data}
            selection={selection}
            showNumber={showNumber}
            isSelected={isSelected}
            loading={loading}
            onSelectRow={handleSelectRow}
            onRowClick={onRowClick}
          />
        </Table>
      </StyledTable>
      {data && data.length ? (
        total && (
          <CustomTableFooter
            total={total}
            page={page}
            onChangePage={onChangePage}
          />
        )
      ) : (
        <NoData />
      )}
    </>
  );
};

export { CustomTable };
